import React from 'react';
import Popper from '@di-shared/features/common/Popper';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';

function HeroTooltip() {
  const {t} = useInferableTranslation();
  return (
    <Popper
      placement="bottom"
      className="tooltip"
      tooltip={
        <div
          tabIndex={0}
          role="tooltip"
          id="tooltipBox01"
        >
          <strong className="tooltip_title">{t('T40212')}</strong>
          <ul className="tooltip_list">
            <li className="tooltip_item">{t('T40213')}</li>
            <li className="tooltip_item">{t('T40214')}</li>
          </ul>
        </div>
      }
    >
      <div className="tooltip_area tooltip_area_single">
        <button
          type="button"
          className="btn_tooltip"
          aria-controls="tooltipStatement01"
          aria-expanded="false"
          aria-describedby="tooltipBox01"
        >
          <span
            className="ic ic_information_16px"
            aria-hidden="true"
          ></span>
        </button>
      </div>
    </Popper>
  );
}

export default HeroTooltip;
